module.exports = "<div class=\"card-header\">\n  <a role=\"button\" (click)=\"toggleClick($event)\">\n    <h5 class=\"mb-0\">\n      <ng-content></ng-content>\n      <i class=\"fa fa-angle-down rotate-icon\"></i>\n    </h5>\n  </a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/typescripts/pro/accordion/components/sb-item.head.html
// module id = ./src/app/typescripts/pro/accordion/components/sb-item.head.html
// module chunks = main